import React from "react";
import { Button } from "@/components/ui/button";
import { TicketIcon } from "@phosphor-icons/react";
import { ReservationRateEdit } from "@/components/ReservationRateEdit";
import { ProformaButton } from "@/components/ProformaDialog";

export const StayActions = ({ res, onChanged, testIdPrefix = "stay" }) => {
  if (!res) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testIdPrefix}-actions`}>
      <ReservationRateEdit res={res} onSaved={onChanged} testIdPrefix={`${testIdPrefix}-rate`} />
      <ProformaButton reservationId={res.id} testIdPrefix={`${testIdPrefix}-proforma`} />
      <Button type="button" size="sm" variant="outline" onClick={() => window.open(`/reservations/${res.id}/voucher`, "_blank")} data-testid={`${testIdPrefix}-voucher-btn`}>
        <TicketIcon size={14} className="mr-1" /> Voucher
      </Button>
    </div>
  );
};
